/* istanbul ignore file */

import TabList from '@mui/lab/TabList';
import { styled } from '../styles';

const Tabs = styled(TabList)(({ theme: { palette } }) => ({
  borderBottom: `1px solid ${palette.layout.line.divider}`,
}));

export default Tabs;
